import { i18n } from '@/plugins/i18n'
import PriorityColumn from './../components/priority-column'
import statusColumn from './../components/status-column'

const priorityTemplate = (row, index, datatable) => {
    let template = new PriorityColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

const statusTemplate = (row, index, datatable) => {
    let template = new statusColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,
        textAlign: 'left', // in rtl version means right
    },
    {
        field: 'creator',
        title: i18n.t('label.creator'),
        sortable: true,
        width: 100,
        template: (row) => {
            return '<a href="/users/' + row.creator_id + '/details">'+row.creator+'</a>'
        },
        textAlign: 'center'
    },
    {
        field: 'category',
        title: i18n.t('label.category'),
        sortable: true,
        width: 80,
        textAlign: 'center'
    },
    {
        field: 'subject',
        title: i18n.t('label.subject'),
        sortable: true,
        width: 90,
        textAlign: 'center'
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        textAlign: 'center'
    },
    {
        field: 'updated_at',
        title: i18n.t('label.updated_at'),
        sortable: true,
        textAlign: 'center'
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        template: (row, index, datatable) => {
            return statusTemplate(row, index, datatable)
        },
        sortable: true,
        width: 80,
        textAlign: 'center'
    },
]